import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
// Ensure runtime config script is present (it is loaded in index.html). If missing, create a minimal object.
// Declared at module top to satisfy lint rule
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const globalWindow: any = window as any;
if (!globalWindow.RUNTIME_CONFIG) {
  globalWindow.RUNTIME_CONFIG = {};
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 